import { Deps, useEffect, useMemo } from "@lukekaalim/act";

type IDisposable = {
  dispose(): void,
}

export const useDisposable = <T extends IDisposable | null>(constructor: () => T, deps: Deps = []) => {
  const disposable = useMemo(constructor, deps);

  useEffect(() => {
    if (!disposable)
      return;

    return () => {
      disposable.dispose();
    }
  }, deps)

  return disposable;
}